import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetExportSettingsMetadataQueryVariables = Types.Exact<{
  input: Types.ExportSettingsMetadataInput;
}>;


export type GetExportSettingsMetadataQuery = { __typename?: 'Query', getExportSettingsMetadata?: { __typename?: 'ExportSettingsMetadata', audio: string, bitRate: string, colorSpace: string, duration: number, estimatedFileSizeMB: string, frameRate: string, resolution: string, format: string } | null };


export const GetExportSettingsMetadata = /*#__PURE__*/ gql`
    query GetExportSettingsMetadata($input: ExportSettingsMetadataInput!) {
  getExportSettingsMetadata(input: $input) {
    audio
    bitRate
    colorSpace
    duration
    estimatedFileSizeMB
    frameRate
    resolution
    format
  }
}
    ` as unknown as DocumentNode<GetExportSettingsMetadataQuery, GetExportSettingsMetadataQueryVariables>;

          

          export const useGetExportSettingsMetadataQuery = (options?:QueryHookOptions<GetExportSettingsMetadataQuery, GetExportSettingsMetadataQueryVariables>) => useQuery(GetExportSettingsMetadata, options);

          

          export type GetExportSettingsMetadataQueryOptions = QueryHookOptions<GetExportSettingsMetadataQuery, GetExportSettingsMetadataQueryVariables>;

          

          export const useGetExportSettingsMetadataLazyQuery = (options?:LazyQueryHookOptions<GetExportSettingsMetadataQuery, GetExportSettingsMetadataQueryVariables>) => useLazyQuery(GetExportSettingsMetadata, options);

          

          export type GetExportSettingsMetadataQueryResult = ReturnType<typeof useGetExportSettingsMetadataQuery>;

          
